import React, {useEffect, useState} from "react";
import Header from "./Header";
import PageHeader from "./PageHeader";
import Sidebar from "./Sidebar";

export default function AppContainer(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Default open for web
  const [isMobileHeaderOpen, setIsMobileHeaderOpen] = useState(false);
  const [isWebView, setIsWebView] = useState(true); // Assume web view initially

  // Update `isWebView` based on window width
  useEffect(() => {
    const handleResize = () => {
      setIsWebView(window.innerWidth > 768); // Web view if width > 768px
      setIsSidebarOpen(window.innerWidth > 768); // Open sidebar if width > 768px
    };

    handleResize(); // Check on initial render
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Toggle sidebar state
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Toggle mobile header state
  const toggleMobileHeader = () => {
    setIsMobileHeaderOpen(!isMobileHeaderOpen);
    setIsSidebarOpen(!isSidebarOpen);
  };


  // Determine dynamic class
  const containerClass = [
    'wrapper',
    'bg-ash',
    isSidebarOpen ? '' : 'sidebar-collapsed',
    !isWebView && isSidebarOpen ? 'sidebar-collapsed-mobile' : '',
    !isWebView && !isSidebarOpen ? 'closed-sidebar-mobile' : ''
  ]
    .filter(Boolean) // Remove empty strings
    .join(' ');


  return (
    <>
      <div
        id="wrapper"
        className={containerClass}>
        {/* Header Menu Area */}
        <Header 
            toggler={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
            mobileHeaderIsOpen={isMobileHeaderOpen}
            toggleMobileHeader={toggleMobileHeader}
            />
        {/* Page Content */}
        <div className="dashboard-page-one">
          {/* Sidebar Area */}
          <Sidebar />


          <div className="dashboard-content-one">
            {/* Page Header */}
            <PageHeader title={props.title} />

            {/* Render child components */}
            {props.children}

            {/* Footer Area */}
            {/* <footer className="footer-wrap-layout1">
              <div className="copyright">
                © Copyrights <a href="#">Buzz Me</a> 2024. All rights reserved.
              </div>
            </footer> */}
          </div>
        </div>
      </div>
    </>
  );
}
